// Array of whitelisted sizes for header bidding.
// Sizes not listed here will not be added to prebid ad units
export const sizes = [
  ['930', '180'],
  ['930', '600'],
  ['160', '600'],
  ['728', '90'],
  ['300', '250'],
  ['300', '600'],
  ['320', '160'],
  ['320', '320'],
];
